import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { APIUrl } from '../../constants';

@Component({
  selector: 'app-accept-offer',
  templateUrl: './accept-offer.component.html',
  styleUrls: ['./accept-offer.component.css']
})
export class AcceptOfferComponent implements OnInit {

  private APIUrl: string = APIUrl;

  offerId: string = '';
  loading: boolean = false;
  error: string = '';

  Offer: any = null;
  MasterData: any = null;

  // Dropdown selections
  selectedConsolidationType: any = null;
  selectedDeliveryPreference: any = null;
  showConsolidationTypeDropdown: boolean = false;
  showDeliveryPreferenceDropdown: boolean = false;

  // Delivery preference blocked state (when multiple brands exist)
  deliveryPreferenceBlocked: boolean = false;

  // Translations object for this public page
  translations: any = {
    EN: {
      DeliveryPreferenceBlockedDescription: 'Orders containing products from multiple brands can only be shipped with partial delivery. This ensures optimal handling and faster processing for each brand.',
      AcceptOfferDisabledDescription: 'All products must have a confirmed price before you can accept this offer. Please contact your agent using the contact details at the top of this page.',
      Insurance: 'Insurance',
      InsuranceValue: 'Insurance Value',
      PricingDisclaimer: 'The quoted prices are valid only for the complete offer. Partial orders or different quantities may be subject to revised pricing.',
      OfferExpiredDisclaimer: 'This offer has expired and is no longer valid. Please contact our team to request an updated quotation.',
      SaveChanges: 'Save changes',
      AddAsNewAddress: 'Add as new shipping address',
      UpdateExistingAddress: 'Update existing shipping address',
      PaymentConditions: 'Payment Conditions',
      PaymentTerms: 'Payment Terms',
      Days: 'Days',
      ContactOurTeam: 'Contact Our Team',
      LegalBankingInfo: 'Legal & Banking Info',
      VAT: 'VAT',
      RegCom: 'Reg. Com.',
      Address: 'Address',
      BankAccount: 'Bank Account',
      OurReference: 'Our Reference',
      YourReference: 'Your Reference',
      OfferDate: 'Date',
      ValidUntil: 'Valid Until',
      Subtotal: 'Subtotal',
      ProjectDiscount: 'Project Discount',
      SubtotalAfterDiscount: 'Subtotal After Discount',
      ShippingCost: 'Shipping Cost',
      GrandTotal: 'Grand Total'
    },
    RO: {
      DeliveryPreferenceBlockedDescription: 'Comenzile care conțin produse de la mai multe mărci pot fi livrate doar cu livrare parțială. Acest lucru asigură o gestionare optimă și o procesare mai rapidă pentru fiecare marcă.',
      AcceptOfferDisabledDescription: 'Toate produsele trebuie să aibă un preț confirmat înainte de a putea accepta această ofertă. Vă rugăm să contactați agentul dvs. folosind datele de contact din partea de sus a acestei pagini.',
      Insurance: 'Asigurare',
      InsuranceValue: 'Valoare Asigurare',
      PricingDisclaimer: 'Prețurile afișate sunt valabile doar pentru oferta completă. Comenzile parțiale sau cantitățile diferite pot fi supuse unor prețuri revizuite.',
      OfferExpiredDisclaimer: 'Această ofertă a expirat și nu mai este valabilă. Vă rugăm să contactați echipa noastră pentru a solicita o ofertă actualizată.',
      SaveChanges: 'Salvează modificările',
      AddAsNewAddress: 'Adaugă ca adresă nouă de livrare',
      UpdateExistingAddress: 'Actualizează adresa de livrare existentă',
      PaymentConditions: 'Conditii de plata',
      PaymentTerms: 'Termen de plata',
      Days: 'Zile',
      ContactOurTeam: 'Contactați Echipa Noastră',
      LegalBankingInfo: 'Informații Legale & Bancare',
      VAT: 'CIF',
      RegCom: 'Reg. Com.',
      Address: 'Adresă',
      BankAccount: 'Cont Bancar',
      OurReference: 'Referința Noastră',
      YourReference: 'Referința Dvs.',
      OfferDate: 'Data',
      ValidUntil: 'Valabil Până La',
      Subtotal: 'Subtotal',
      ProjectDiscount: 'Discount Proiect',
      SubtotalAfterDiscount: 'Subtotal După Discount',
      ShippingCost: 'Cost de transport',
      GrandTotal: 'Total General'
    },
    DE: {
      DeliveryPreferenceBlockedDescription: 'Bestellungen mit Produkten verschiedener Marken können nur mit Teillieferung versendet werden. Dies gewährleistet eine optimale Handhabung und schnellere Bearbeitung für jede Marke.',
      AcceptOfferDisabledDescription: 'Alle Produkte müssen einen bestätigten Preis haben, bevor Sie dieses Angebot annehmen können. Bitte kontaktieren Sie Ihren Ansprechpartner über die Kontaktdaten oben auf dieser Seite.',
      Insurance: 'Versicherung',
      InsuranceValue: 'Versicherungswert',
      PricingDisclaimer: 'Die angegebenen Preise gelten nur für das vollständige Angebot. Teilbestellungen oder abweichende Mengen können zu geänderten Preisen führen.',
      OfferExpiredDisclaimer: 'Dieses Angebot ist abgelaufen und nicht mehr gültig. Bitte kontaktieren Sie unser Team, um ein aktualisiertes Angebot anzufordern.',
      SaveChanges: 'Änderungen speichern',
      AddAsNewAddress: 'Als neue Lieferadresse hinzufügen',
      UpdateExistingAddress: 'Bestehende Lieferadresse aktualisieren',
      PaymentConditions: 'Zahlungsbedingungen',
      PaymentTerms: 'Zahlungsziel',
      Days: 'Tage',
      ContactOurTeam: 'Kontaktieren Sie Unser Team',
      LegalBankingInfo: 'Rechtliche & Bankdaten',
      VAT: 'USt-IdNr.',
      RegCom: 'Handelsregister',
      Address: 'Adresse',
      BankAccount: 'Bankkonto',
      OurReference: 'Unsere Referenz',
      YourReference: 'Ihre Referenz',
      OfferDate: 'Datum',
      ValidUntil: 'Gültig Bis',
      Subtotal: 'Zwischensumme',
      ProjectDiscount: 'Projektrabatt',
      SubtotalAfterDiscount: 'Zwischensumme nach Rabatt',
      ShippingCost: 'Versandkosten',
      GrandTotal: 'Gesamtsumme'
    },
    ES: {
      DeliveryPreferenceBlockedDescription: 'Los pedidos que contienen productos de múltiples marcas solo pueden enviarse con entrega parcial. Esto garantiza un manejo óptimo y un procesamiento más rápido para cada marca.',
      AcceptOfferDisabledDescription: 'Todos los productos deben tener un precio confirmado antes de poder aceptar esta oferta. Por favor, contacte a su agente utilizando los datos de contacto en la parte superior de esta página.',
      Insurance: 'Seguro',
      InsuranceValue: 'Valor del Seguro',
      PricingDisclaimer: 'Los precios indicados son válidos solo para la oferta completa. Los pedidos parciales o cantidades diferentes pueden estar sujetos a precios revisados.',
      OfferExpiredDisclaimer: 'Esta oferta ha expirado y ya no es válida. Por favor, contacte a nuestro equipo para solicitar una cotización actualizada.',
      SaveChanges: 'Guardar cambios',
      AddAsNewAddress: 'Agregar como nueva dirección de envío',
      UpdateExistingAddress: 'Actualizar dirección de envío existente',
      PaymentConditions: 'Condiciones de pago',
      PaymentTerms: 'Plazo de pago',
      Days: 'Días',
      ContactOurTeam: 'Contacte a Nuestro Equipo',
      LegalBankingInfo: 'Información Legal y Bancaria',
      VAT: 'NIF/CIF',
      RegCom: 'Registro Mercantil',
      Address: 'Dirección',
      BankAccount: 'Cuenta Bancaria',
      OurReference: 'Nuestra Referencia',
      YourReference: 'Su Referencia',
      OfferDate: 'Fecha',
      ValidUntil: 'Válido Hasta',
      Subtotal: 'Subtotal',
      ProjectDiscount: 'Descuento de Proyecto',
      SubtotalAfterDiscount: 'Subtotal Después del Descuento',
      ShippingCost: 'Costo de Envío',
      GrandTotal: 'Total General'
    },
    FR: {
      DeliveryPreferenceBlockedDescription: 'Les commandes contenant des produits de plusieurs marques ne peuvent être expédiées qu\'en livraison partielle. Cela garantit une gestion optimale et un traitement plus rapide pour chaque marque.',
      AcceptOfferDisabledDescription: 'Tous les produits doivent avoir un prix confirmé avant de pouvoir accepter cette offre. Veuillez contacter votre agent en utilisant les coordonnées en haut de cette page.',
      Insurance: 'Assurance',
      InsuranceValue: 'Valeur d\'Assurance',
      PricingDisclaimer: 'Les prix indiqués ne sont valables que pour l\'offre complète. Les commandes partielles ou les quantités différentes peuvent être soumises à des prix révisés.',
      OfferExpiredDisclaimer: 'Cette offre a expiré et n\'est plus valable. Veuillez contacter notre équipe pour demander un devis actualisé.',
      SaveChanges: 'Enregistrer les modifications',
      AddAsNewAddress: 'Ajouter comme nouvelle adresse de livraison',
      UpdateExistingAddress: 'Mettre à jour l\'adresse de livraison existante',
      PaymentConditions: 'Conditions de paiement',
      PaymentTerms: 'Délai de paiement',
      Days: 'Jours',
      ContactOurTeam: 'Contactez Notre Équipe',
      LegalBankingInfo: 'Informations Légales et Bancaires',
      VAT: 'N° TVA',
      RegCom: 'N° SIREN',
      Address: 'Adresse',
      BankAccount: 'Compte Bancaire',
      OurReference: 'Notre Référence',
      YourReference: 'Votre Référence',
      OfferDate: 'Date',
      ValidUntil: 'Valable Jusqu\'au',
      Subtotal: 'Sous-total',
      ProjectDiscount: 'Remise Projet',
      SubtotalAfterDiscount: 'Sous-total Après Remise',
      ShippingCost: 'Coût d\'Expédition',
      GrandTotal: 'Total Général'
    },
    IT: {
      DeliveryPreferenceBlockedDescription: 'Gli ordini contenenti prodotti di più marchi possono essere spediti solo con consegna parziale. Questo garantisce una gestione ottimale e un\'elaborazione più rapida per ogni marca.',
      AcceptOfferDisabledDescription: 'Tutti i prodotti devono avere un prezzo confermato prima di poter accettare questa offerta. Si prega di contattare il proprio agente utilizzando i dettagli di contatto nella parte superiore di questa pagina.',
      Insurance: 'Assicurazione',
      InsuranceValue: 'Valore Assicurazione',
      PricingDisclaimer: 'I prezzi indicati sono validi solo per l\'offerta completa. Gli ordini parziali o quantità diverse possono essere soggetti a prezzi rivisti.',
      OfferExpiredDisclaimer: 'Questa offerta è scaduta e non è più valida. Si prega di contattare il nostro team per richiedere un preventivo aggiornato.',
      SaveChanges: 'Salva modifiche',
      AddAsNewAddress: 'Aggiungi come nuovo indirizzo di spedizione',
      UpdateExistingAddress: 'Aggiorna indirizzo di spedizione esistente',
      PaymentConditions: 'Condizioni di pagamento',
      PaymentTerms: 'Termini di pagamento',
      Days: 'Giorni',
      ContactOurTeam: 'Contatta il Nostro Team',
      LegalBankingInfo: 'Informazioni Legali e Bancarie',
      VAT: 'P.IVA',
      RegCom: 'Reg. Imprese',
      Address: 'Indirizzo',
      BankAccount: 'Conto Bancario',
      OurReference: 'Nostro Riferimento',
      YourReference: 'Vostro Riferimento',
      OfferDate: 'Data',
      ValidUntil: 'Valido Fino Al',
      Subtotal: 'Subtotale',
      ProjectDiscount: 'Sconto Progetto',
      SubtotalAfterDiscount: 'Subtotale Dopo Sconto',
      ShippingCost: 'Costo Spedizione',
      GrandTotal: 'Totale Complessivo'
    },
    PL: {
      DeliveryPreferenceBlockedDescription: 'Zamówienia zawierające produkty wielu marek mogą być wysyłane tylko z częściową dostawą. Zapewnia to optymalną obsługę i szybsze przetwarzanie dla każdej marki.',
      AcceptOfferDisabledDescription: 'Wszystkie produkty muszą mieć potwierdzoną cenę, zanim będziesz mógł zaakceptować tę ofertę. Skontaktuj się ze swoim agentem, korzystając z danych kontaktowych na górze tej strony.',
      Insurance: 'Ubezpieczenie',
      InsuranceValue: 'Wartość Ubezpieczenia',
      PricingDisclaimer: 'Podane ceny obowiązują tylko dla pełnej oferty. Zamówienia częściowe lub różne ilości mogą podlegać zmienionym cenom.',
      OfferExpiredDisclaimer: 'Ta oferta wygasła i nie jest już ważna. Skontaktuj się z naszym zespołem, aby poprosić o zaktualizowaną wycenę.',
      SaveChanges: 'Zapisz zmiany',
      AddAsNewAddress: 'Dodaj jako nowy adres wysyłki',
      UpdateExistingAddress: 'Zaktualizuj istniejący adres wysyłki',
      PaymentConditions: 'Warunki płatności',
      PaymentTerms: 'Termin płatności',
      Days: 'Dni',
      ContactOurTeam: 'Skontaktuj się z Naszym Zespołem',
      LegalBankingInfo: 'Informacje Prawne i Bankowe',
      VAT: 'NIP',
      RegCom: 'KRS',
      Address: 'Adres',
      BankAccount: 'Konto Bankowe',
      OurReference: 'Nasza Referencja',
      YourReference: 'Wasza Referencja',
      OfferDate: 'Data',
      ValidUntil: 'Ważne Do',
      Subtotal: 'Suma Częściowa',
      ProjectDiscount: 'Rabat Projektowy',
      SubtotalAfterDiscount: 'Suma Częściowa Po Rabacie',
      ShippingCost: 'Koszt Wysyłki',
      GrandTotal: 'Suma Całkowita'
    },
    PT: {
      DeliveryPreferenceBlockedDescription: 'Encomendas contendo produtos de múltiplas marcas só podem ser enviadas com entrega parcial. Isto garante um manuseio ideal e processamento mais rápido para cada marca.',
      AcceptOfferDisabledDescription: 'Todos os produtos devem ter um preço confirmado antes de poder aceitar esta oferta. Por favor, contacte o seu agente utilizando os detalhes de contacto no topo desta página.',
      Insurance: 'Seguro',
      InsuranceValue: 'Valor do Seguro',
      PricingDisclaimer: 'Os preços indicados são válidos apenas para a oferta completa. Encomendas parciais ou quantidades diferentes podem estar sujeitas a preços revistos.',
      OfferExpiredDisclaimer: 'Esta oferta expirou e já não é válida. Por favor, contacte a nossa equipa para solicitar um orçamento atualizado.',
      SaveChanges: 'Salvar alterações',
      AddAsNewAddress: 'Adicionar como novo endereço de envio',
      UpdateExistingAddress: 'Atualizar endereço de envio existente',
      PaymentConditions: 'Condições de pagamento',
      PaymentTerms: 'Prazo de pagamento',
      Days: 'Dias',
      ContactOurTeam: 'Contacte a Nossa Equipa',
      LegalBankingInfo: 'Informações Legais e Bancárias',
      VAT: 'NIF',
      RegCom: 'Registo Comercial',
      Address: 'Morada',
      BankAccount: 'Conta Bancária',
      OurReference: 'Nossa Referência',
      YourReference: 'Sua Referência',
      OfferDate: 'Data',
      ValidUntil: 'Válido Até',
      Subtotal: 'Subtotal',
      ProjectDiscount: 'Desconto de Projeto',
      SubtotalAfterDiscount: 'Subtotal Após Desconto',
      ShippingCost: 'Custo de Envio',
      GrandTotal: 'Total Geral'
    }
  };

  // Shipping address dropdown
  PartnerShippingAddresses: any[] = [];
  selectedShippingAddress: any = null;
  showShippingAddressDropdown: boolean = false;

  // Shipping address snapshot for change detection
  shippingAddressSnapshot: any = null;
  shippingAddressChanged: boolean = false;
  showSaveAddressDropdown: boolean = false;
  selectedSaveOption: 'new' | 'update' | null = null;

  // Shipping dropdowns (country-specific)
  ShippingCompanies: any[] = [];
  selectedShippingResponsability: any = null;
  selectedShippingCompany: any = null;
  selectedShippingServiceType: any = null;
  showShippingResponsabilityDropdown: boolean = false;
  showShippingCompanyDropdown: boolean = false;
  showShippingServiceTypeDropdown: boolean = false;

  // DebatorPO textbox
  debatorPO: string = '';

  // All items must have CartItemStatus.ID === 1 to accept offer
  allItemsHavePrice: boolean = true;

  // Accept offer state
  accepting: boolean = false;
  acceptSuccess: boolean = false;
  acceptError: string = '';
  createdOrderConfirmation: any = null;

  // Already accepted state (OfferStatus.ID == 12)
  alreadyAccepted: boolean = false;

  // PO confirmation popup
  showPOConfirmPopup: boolean = false;

  // Original DB value of HasInsurance - used to determine if we should force insurance
  originalDBHasInsurance: boolean = false;

  // Show ListPrice/Discount columns based on PDFColumns settings
  // Both must be true to show, otherwise hide both
  get showListPriceDiscount(): boolean {
    const pdfColumns = this.Offer?.PDFColumns;
    return (pdfColumns?.ListPrice === true) && (pdfColumns?.Discount === true);
  }

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient
  ) { }

  // Language based on partner country
  language: string = 'EN';

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.offerId = params['id'] || '';
      console.log('Accept Offer - ID:', this.offerId);

      if (this.offerId) {
        // First get the offer, then get master data with correct language
        this.GetOffer();
      } else {
        this.error = 'No offer ID provided';
      }
    });
  }

  // ✅ Public endpoint - no authentication required
  GetOffer() {
    this.loading = true;

    this.http.get<any>(this.APIUrl + '/api/Offers/Public/Get/Offer/' + this.offerId).subscribe(response => {
      if (response["Status"] != 1) {
        this.error = response["Message"] || 'Failed to load offer';
        this.loading = false;
      } else {
        this.Offer = response["Offer"];
        this.debatorPO = this.Offer?.DebatorPO || '';
        this.selectedConsolidationType = this.Offer?.ConsolidationType || null;
        this.selectedDeliveryPreference = this.Offer?.DeliveryPreference || null;

        // Initialize shipping selections from Cart
        this.selectedShippingResponsability = this.Offer?.Cart?.ShippingResponsability || null;
        this.selectedShippingCompany = this.Offer?.Cart?.ShippingCompany || null;
        this.selectedShippingServiceType = this.Offer?.Cart?.ShippingServiceType || null;

        // Store original DB value of HasInsurance
        this.originalDBHasInsurance = this.Offer?.Cart?.HasInsurance === true;

        console.log('✅ Offer loaded:', this.Offer);

        // ✅ Check if offer is already accepted (OfferStatus.ID == 12)
        if (this.Offer?.OfferStatus?.ID === 12) {
          this.alreadyAccepted = true;
          this.loading = false;
          return;
        }

        // Determine language from partner country
        const countryShortName = this.Offer?.Cart?.Partner?.Country?.ShortName?.toUpperCase();
        this.language = countryShortName === 'RO' ? 'RO' : 'EN';
        console.log('🌐 Language set to:', this.language);

        // Check if delivery preference should be blocked (multiple brands)
        this.checkDeliveryPreferenceBlocked();

        // Check if all items have confirmed prices (CartItemStatus.ID === 1)
        this.checkAllItemsHavePrice();

        // Get partner shipping addresses
        const partnerId = this.Offer?.Cart?.Partner?.ID;
        if (partnerId) {
          this.GetPartnerShippingAddresses(partnerId);
        }

        // Now get master data with correct language
        this.GetOfferMasterData();
      }
    }, () => {
      this.error = 'Failed to connect to server';
      this.loading = false;
    });
  }

  // ✅ Public endpoint - no authentication required
  GetOfferMasterData() {
    this.http.get<any>(this.APIUrl + '/api/Offers/Public/Get/Offer/Master/Data/' + this.language).subscribe(response => {
      if (response["Status"] === 1) {
        this.MasterData = response;
        console.log('✅ Master Data loaded:', this.MasterData);

        // Use shipping responsability from Cart (set by admin), don't override
        // selectedShippingResponsability is already set from Cart in loadOffer()

        // Re-check delivery preference blocking now that master data is loaded
        // This ensures we use the correct Partial Delivery object from master data
        this.checkDeliveryPreferenceBlocked();
      }
      this.loading = false;
    });
  }

  // ✅ Public endpoint - get partner shipping addresses
  GetPartnerShippingAddresses(partnerId: string) {
    this.http.get<any>(this.APIUrl + '/api/Offers/Public/Get/Partner/Shipping/Addresses/' + partnerId).subscribe(response => {
      if (response["Status"] === 1) {
        this.PartnerShippingAddresses = response["ShippingAddresses"] || [];
        console.log('✅ Partner Shipping Addresses loaded:', this.PartnerShippingAddresses);

        // Auto-select first shipping address if none selected
        if (this.PartnerShippingAddresses.length > 0 && !this.selectedShippingAddress) {
          this.selectShippingAddress(this.PartnerShippingAddresses[0]);
        }
      }
    });
  }

  // Get country shipping options based on selected shipping address
  GetCountryShippingOptions(country: any) {
    if (!country?.ID) return;

    const request = {
      Language: this.language,
      Country: country,
      PartnerID: this.Offer?.Cart?.Partner?.ID,
      DirectionID: 1 // export (sending to customer)
    };

    this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Country/Shipping/Options', request).subscribe(response => {
      if (response["Status"] === 1) {
        this.ShippingCompanies = response["ShippingCompanies"] || [];
        console.log('✅ Country Shipping Options loaded:', this.ShippingCompanies);

        // ✅ Match selectedShippingCompany ID with full object from country options (to get Name, Logo, etc.)
        if (this.selectedShippingCompany?.ID && this.ShippingCompanies.length > 0) {
          const matchedCompany = this.ShippingCompanies.find(c => c.ID === this.selectedShippingCompany.ID);
          if (matchedCompany) {
            this.selectShippingCompany(matchedCompany);
          }
        }
        // Only auto-select if no shipping company was set by admin in Cart
        else if (this.ShippingCompanies.length > 0 && !this.selectedShippingCompany?.ID) {
          const selectedCompany = this.ShippingCompanies.find(x => x.IsSelected) || this.ShippingCompanies[0];
          this.selectShippingCompany(selectedCompany);
        }
      }
    });
  }

  // Dropdown methods
  onConsolidationTypeFocus() {
    this.showDeliveryPreferenceDropdown = false;
    this.showConsolidationTypeDropdown = true;
  }

  onDeliveryPreferenceFocus() {
    this.showConsolidationTypeDropdown = false;
    this.showDeliveryPreferenceDropdown = true;
  }

  selectConsolidationType(type: any) {
    this.selectedConsolidationType = type;
    this.showConsolidationTypeDropdown = false;
    if (this.Offer) {
      this.Offer.ConsolidationType = type;
    }
  }

  selectDeliveryPreference(pref: any) {
    this.selectedDeliveryPreference = pref;
    this.showDeliveryPreferenceDropdown = false;
    if (this.Offer) {
      this.Offer.DeliveryPreference = pref;
    }
  }

  closeDropdowns() {
    this.showConsolidationTypeDropdown = false;
    this.showDeliveryPreferenceDropdown = false;
    this.showShippingAddressDropdown = false;
    this.showShippingResponsabilityDropdown = false;
    this.showShippingCompanyDropdown = false;
    this.showShippingServiceTypeDropdown = false;
  }

  // Shipping Address dropdown methods
  onShippingAddressFocus() {
    this.closeDropdowns();
    this.showShippingAddressDropdown = true;
  }

  selectShippingAddress(address: any) {
    this.selectedShippingAddress = address;
    this.showShippingAddressDropdown = false;

    // Create snapshot for change detection
    this.shippingAddressSnapshot = JSON.parse(JSON.stringify(address));
    this.shippingAddressChanged = false;
    this.showSaveAddressDropdown = false;

    // Update offer shipping address
    if (this.Offer) {
      this.Offer.ShippingAddress = address;
    }

    // Get country-specific shipping options
    if (address?.Country) {
      this.GetCountryShippingOptions(address.Country);
    }
  }

  getShippingAddressDisplay(address: any): string {
    if (!address) return 'Select...';
    const parts = [];
    if (address.Country?.Name) parts.push(address.Country.Name);
    if (address.City) parts.push(address.City);
    if (address.AddressLine) parts.push(address.AddressLine);
    return parts.join(', ') || 'Select...';
  }

  // Shipping dropdown methods
  onShippingResponsabilityFocus() {
    this.closeDropdowns();
    this.showShippingResponsabilityDropdown = true;
  }

  onShippingCompanyFocus() {
    this.closeDropdowns();
    this.showShippingCompanyDropdown = true;
  }

  onShippingServiceTypeFocus() {
    this.closeDropdowns();
    this.showShippingServiceTypeDropdown = true;
  }

  selectShippingResponsability(item: any) {
    this.selectedShippingResponsability = item;
    this.showShippingResponsabilityDropdown = false;
    if (this.Offer?.Cart) {
      this.Offer.Cart.ShippingResponsability = item;
      // Only force insurance if the original DB value was true AND the shipping type requires it
      // If original DB value was false, let the user decide freely
      if (this.originalDBHasInsurance === true && item?.RequiresInsurance === true) {
        this.Offer.Cart.HasInsurance = true;
      }
    }
  }

  selectShippingCompany(item: any) {
    this.selectedShippingCompany = item;
    this.showShippingCompanyDropdown = false;
    if (this.Offer?.Cart) {
      this.Offer.Cart.ShippingCompany = item;
    }
  }

  selectShippingServiceType(item: any) {
    this.selectedShippingServiceType = item;
    this.showShippingServiceTypeDropdown = false;
    if (this.Offer?.Cart) {
      this.Offer.Cart.ShippingServiceType = item;
    }
  }

  onDebatorPOChange(value: string) {
    this.debatorPO = value;
    if (this.Offer) {
      this.Offer.DebatorPO = value;
    }
  }

  // Calculate discount percentage: (1 - sellPrice / listPrice) * 100
  getDiscountPercent(item: any): string {
    const sellPrice = item?.SelectedOffer?.SellingPrice || item?.SelectedOffer?.SellPrice?.UIUnitPrice || item?.Price?.UIUnitPrice;
    const listPrice = item?.Product?.Stats?.StandardListPrice?.UIUnitPrice;

    if (sellPrice != null && listPrice != null && listPrice > 0) {
      const discount = Math.round((1 - sellPrice / listPrice) * 100);
      if (discount > 0 && discount <= 100) {
        return discount + '%';
      }
    }
    return '-';
  }

  // Get item total (quantity * final price)
  getItemTotal(item: any): string {
    // First try Price.UIQtyPrice
    if (item?.Price?.UIQtyPrice != null && item.Price.UIQtyPrice !== 0) {
      return item.Price.UIQtyPrice;
    }
    // Calculate from quantity and final price
    const qty = item?.Quantity || 0;
    const finalPrice = item?.SelectedOffer?.SellingPrice || item?.SelectedOffer?.SellPrice?.UIUnitPrice || item?.Price?.UIUnitPrice || 0;
    if (qty > 0 && finalPrice > 0) {
      const total = Math.round(qty * finalPrice * 100) / 100;
      return total.toString();
    }
    return '-';
  }

  // Get cart subtotal (sum of all item totals)
  getCartSubtotal(): number {
    const items = this.Offer?.Cart?.Items || [];
    let subtotal = 0;
    for (const item of items) {
      const itemTotal = parseFloat(this.getItemTotal(item));
      if (!isNaN(itemTotal)) {
        subtotal += itemTotal;
      }
    }
    return Math.round(subtotal * 100) / 100;
  }

  // Get insurance value (1% of subtotal)
  getInsuranceValue(): string {
    const subtotal = this.getCartSubtotal();
    const insuranceValue = Math.round(subtotal * 0.01 * 100) / 100;
    return insuranceValue.toFixed(2);
  }

  // Get project discount amount (OriginalTotal - Total after discount)
  getProjectDiscountAmount(): string {
    const originalTotal = this.Offer?.Cart?.OriginalTotal?.TotalQtyPriceNOVAT || 0;
    const discountedTotal = this.Offer?.Cart?.Total?.TotalQtyPriceNOVAT || 0;
    const discountAmount = originalTotal - discountedTotal;
    return discountAmount.toFixed(2);
  }

  // Get absolute total (Subtotal after discount + Shipping Cost)
  getAbsoluteTotal(): string {
    const subtotalAfterDiscount = this.Offer?.Cart?.Total?.TotalQtyPriceNOVAT || 0;
    const shippingCost = this.Offer?.Cart?.ShippingCost?.UIUnitPrice || 0;
    const absoluteTotal = subtotalAfterDiscount + shippingCost;
    return absoluteTotal.toFixed(2);
  }

  // Scroll to insurance section and highlight it
  scrollToInsuranceSection() {
    const insuranceSection = document.getElementById('insurance-section');
    if (insuranceSection) {
      insuranceSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Add highlight animation class after scrolling
      setTimeout(() => {
        insuranceSection.classList.add('highlight-animation');
        // Remove the class after animation completes (5 pulses * 600ms = 3000ms)
        setTimeout(() => {
          insuranceSection.classList.remove('highlight-animation');
        }, 3000);
      }, 500);
    }
  }

  // Scroll to contact section and highlight it (for expired offer)
  scrollToContactSection() {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Add highlight animation class after scrolling
      setTimeout(() => {
        contactSection.classList.add('highlight-animation');
        // Remove the class after animation completes (5 pulses * 600ms = 3000ms)
        setTimeout(() => {
          contactSection.classList.remove('highlight-animation');
        }, 3000);
      }, 500);
    }
  }

  // Open datasheet link in a new tab
  openDatasheet(url: string) {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  // Handle Accept button click - check for PO first
  onAcceptClick() {
    if (!this.debatorPO || this.debatorPO.trim() === '') {
      this.showPOConfirmPopup = true;
    } else {
      this.AcceptOffer();
    }
  }

  closePOConfirmPopup() {
    this.showPOConfirmPopup = false;
  }

  confirmAcceptWithoutPO() {
    this.showPOConfirmPopup = false;
    this.AcceptOffer();
  }

  // Accept Offer - Create Order Confirmation
  AcceptOffer() {
    if (this.accepting || !this.Offer) return;

    this.accepting = true;
    this.acceptError = '';

    // If shipping address was changed, save it first
    if (this.shippingAddressChanged && this.selectedSaveOption) {
      this.saveShippingAddress();
    }

    const request = {
      OfferID: this.offerId,
      Language: this.language,
      DebatorPO: this.debatorPO,
      ConsolidationTypeID: this.selectedConsolidationType?.ID || null,
      DeliveryPreferenceID: this.selectedDeliveryPreference?.ID || null,
      ShippingAddressID: this.selectedShippingAddress?.ID || null,
      ShippingResponsabilityID: this.selectedShippingResponsability?.ID || null,
      ShippingCompanyID: this.selectedShippingCompany?.ID || null,
      ShippingServiceTypeID: this.selectedShippingServiceType?.ID || null,
      SendEmail: true
    };

    this.http.post<any>(this.APIUrl + '/api/Offers/Public/Add/OrderConfirmation/From/Offer', request)
      .subscribe(response => {
        this.accepting = false;

        if (response["Status"] === 1) {
          this.acceptSuccess = true;
          this.createdOrderConfirmation = response["OrderConfirmation"];
          console.log('✅ Order Confirmation created:', this.createdOrderConfirmation);
        } else {
          this.acceptError = response["Message"] || 'Failed to accept offer';
        }
      }, (error) => {
        this.accepting = false;
        this.acceptError = 'Failed to connect to server';
        console.error('❌ Accept offer error:', error);
      });
  }

  // Check if delivery preference should be blocked (multiple brands in cart)
  checkDeliveryPreferenceBlocked() {
    const items = this.Offer?.Cart?.Items || [];

    // Get distinct brand IDs (only count items with valid brands)
    const brandIds = items
      .filter((item: any) => item?.Product?.Brand?.ID > 0)
      .map((item: any) => item.Product.Brand.ID);

    const uniqueBrandIds = [...new Set(brandIds)];
    const hasMultipleBrands = uniqueBrandIds.length > 1;

    // Also check if any item has no brand (considered as a different "brand")
    const hasItemsWithoutBrand = items.some((item: any) => !item?.Product?.Brand?.ID || item.Product.Brand.ID === 0);

    if (hasMultipleBrands || (hasItemsWithoutBrand && uniqueBrandIds.length >= 1)) {
      this.deliveryPreferenceBlocked = true;

      // Force to Partial Delivery (ID = -1)
      if (this.MasterData?.OrderDeliveryPreferences) {
        const partialDelivery = this.MasterData.OrderDeliveryPreferences.find((d: any) => d.ID === -1);
        if (partialDelivery) {
          this.selectedDeliveryPreference = partialDelivery;
          if (this.Offer) {
            this.Offer.DeliveryPreference = partialDelivery;
          }
        }
      } else if (this.selectedDeliveryPreference?.ID !== -1) {
        // If master data not loaded yet, just force the ID to -1
        this.selectedDeliveryPreference = { ID: -1, Name: this.language === 'RO' ? 'Livrare Parțială' : 'Partial Delivery' };
        if (this.Offer) {
          this.Offer.DeliveryPreference = this.selectedDeliveryPreference;
        }
      }

      console.log('🔒 Delivery preference blocked - multiple brands detected');
    } else {
      this.deliveryPreferenceBlocked = false;
    }
  }

  // Get translated text for this public page
  getTranslation(key: string): string {
    return this.translations[this.language]?.[key] || this.translations['EN']?.[key] || key;
  }

  // Check if all cart items have a final price
  checkAllItemsHavePrice() {
    const items = this.Offer?.Cart?.Items || [];

    if (items.length === 0) {
      this.allItemsHavePrice = false;
      return;
    }

    // All items must have a final price to enable accept button
    // Final price can come from: SelectedOffer.SellingPrice, SelectedOffer.SellPrice.UIUnitPrice, or Price.UIUnitPrice
    this.allItemsHavePrice = items.every((item: any) => {
      const finalPrice = item?.SelectedOffer?.SellingPrice || item?.SelectedOffer?.SellPrice?.UIUnitPrice || item?.Price?.UIUnitPrice;
      return finalPrice && finalPrice > 0;
    });

    if (!this.allItemsHavePrice) {
      console.log('⚠️ Not all items have final prices - accept button disabled');
    }
  }

  // Normalize string for comparison (similar to CommonUtilities.ClearSearchTermUpperCase)
  normalizeForComparison(value: string | null | undefined): string {
    if (!value) return '';
    return value
      .replace(/\s+/g, '')
      .replace(/\./g, '')
      .replace(/-/g, '')
      .replace(/:/g, '')
      .replace(/;/g, '')
      .replace(/,/g, '')
      .replace(/\//g, '')
      .replace(/_/g, '')
      .toUpperCase();
  }

  // Check if shipping address has changed from snapshot
  checkShippingAddressChanged() {
    if (!this.selectedShippingAddress || !this.shippingAddressSnapshot) {
      this.shippingAddressChanged = false;
      return;
    }

    const current = this.selectedShippingAddress;
    const snapshot = this.shippingAddressSnapshot;

    // Compare Country by ID
    const countryChanged = (current.Country?.ID || 0) !== (snapshot.Country?.ID || 0);

    // Compare string fields using normalization
    const fieldsToCompare = ['ContactName', 'AddressLine', 'City', 'ZipCode', 'StateProvince', 'Email', 'Phone'];

    let fieldChanged = false;
    for (const field of fieldsToCompare) {
      if (this.normalizeForComparison(current[field]) !== this.normalizeForComparison(snapshot[field])) {
        fieldChanged = true;
        break;
      }
    }

    const hasChanged = countryChanged || fieldChanged;

    // If just became changed, preselect "update" as default
    if (hasChanged && !this.shippingAddressChanged) {
      this.selectedSaveOption = 'update';
    }

    // If no longer changed, reset the selection
    if (!hasChanged) {
      this.selectedSaveOption = null;
    }

    this.shippingAddressChanged = hasChanged;
  }

  // Toggle save address dropdown
  toggleSaveAddressDropdown() {
    this.showSaveAddressDropdown = !this.showSaveAddressDropdown;
  }

  // Select save option (just updates the selection, doesn't save yet)
  selectSaveOption(option: 'new' | 'update') {
    this.selectedSaveOption = option;
    this.showSaveAddressDropdown = false;
  }

  // Get the display text for selected save option
  getSaveOptionText(): string {
    if (this.selectedSaveOption === 'new') {
      return this.getTranslation('AddAsNewAddress');
    } else if (this.selectedSaveOption === 'update') {
      return this.getTranslation('UpdateExistingAddress');
    }
    return this.getTranslation('SaveChanges');
  }

  // Actually save the shipping address (called when accepting offer or explicitly)
  saveShippingAddress() {
    if (!this.selectedShippingAddress || !this.selectedSaveOption) return;

    const addressToSave = JSON.parse(JSON.stringify(this.selectedShippingAddress));

    // Only keep original ID if updating existing, otherwise set to 0 for new
    const isUpdate = this.selectedSaveOption === 'update';
    if (!isUpdate) {
      addressToSave.ID = 0;
    }

    const request = {
      Language: this.language,
      ShippingAddress: addressToSave,
      PartnerID: this.Offer?.Cart?.Partner?.ID
    };

    console.log('📤 Saving shipping address:', request);

    this.http.post<any>(this.APIUrl + '/api/Offers/Public/Add/Update/Shipping/Address', request).subscribe(response => {
      if (response["Status"] === 1) {
        console.log('✅ Shipping address saved successfully:', response);

        // Update the selected address with the response
        if (response["ShippingAddress"]) {
          this.selectedShippingAddress = response["ShippingAddress"];

          // If added as new, add to the list
          if (!isUpdate) {
            this.PartnerShippingAddresses.push(response["ShippingAddress"]);
          }
        }

        // Update snapshot and reset state
        this.shippingAddressSnapshot = JSON.parse(JSON.stringify(this.selectedShippingAddress));
        this.shippingAddressChanged = false;
        this.selectedSaveOption = null;
      } else {
        console.error('❌ Failed to save shipping address:', response["Message"]);
      }
    }, error => {
      console.error('❌ Error saving shipping address:', error);
    });
  }

}
